module.exports = __webpack_public_path__ + "img/icon-flag-pt.c9a4eb89.svg";